module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Social-Static-Ad-w720.84b11a85.webp";